import {
  useQueryState,
  parseAsInteger,
  parseAsString,
  parseAsBoolean,
  parseAsStringEnum,
  parseAsArrayOf,
  parseAsIsoDate,
} from "nuqs";

import { LeadStatus } from "@/entities/lead-v2";
import { LeadLinkStatus } from "@/entities/lead-link";
import { ManagerStatus } from "@/entities/manager";
import { PayoutStatus } from "@/entities/payment";
import { Roles } from "@/entities/user";

export enum QueryParams {
  TAB = "tab",
  SEARCH = "search",
  SEARCH_BY = "searchBy",
  PAGE = "page",
  ROLE = "role",
  SORT = "sort",
  ORDER = "order",
  STATUS = "status",
  LEAD_STATUS = "leadStatus",
  LINK_STATUS = "linkStatus",
  MANAGER_STATUS = "managerStatus",
  PAYOUT_STATUS = "payoutStatus",
  TYPE = "type",
  LENGTH = "length",
  LEAD_ID = "leadId",
  IS_BANNED = "isBanned",
  IS_ACTIVE = "isActive",
  IS_IRRELEVANT = "isIrrelevant",
  IS_DEAD = "isDead",
  EXCLUDED_STATUS = "excludeStatus",
  SELECTED_USER_ID = "selectedUserId",
  SELECTED_USER_ROLE = "selectedUserRole",
  SELECTED_USER_NAME = "selectedUserName",
  CREATED_AT_FROM = "createdAtFrom",
  CREATED_AT_TO = "createdAtTo",
}

export const useURLParamsData = () => {
  const [search, setSearch] = useQueryState(QueryParams.SEARCH, {
    defaultValue: "",
  });
  const [page, setPage] = useQueryState(
    QueryParams.PAGE,
    parseAsInteger.withDefault(1),
  );

  const [sort, setSort] = useQueryState(QueryParams.SORT, {
    defaultValue: "",
  });
  const [order, setOrder] = useQueryState(
    QueryParams.ORDER,
    parseAsStringEnum<"asc" | "desc">(["asc", "desc"]),
  );
  const [leadStatus, setLeadStatus] = useQueryState(
    QueryParams.LEAD_STATUS,
    parseAsStringEnum<LeadStatus>(Object.values(LeadStatus)),
  );
  // УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!
  const [status, setStatus] = useQueryState(QueryParams.STATUS, {
    defaultValue: "",
  });
  // УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!УБРАТЬ!!!!!!!!!!
  const [searchByState, setSearchByState] = useQueryState(
    QueryParams.SEARCH_BY,
    parseAsArrayOf(parseAsString),
  );
  const [linkStatus, setLinkStatus] = useQueryState(
    QueryParams.LINK_STATUS,
    parseAsStringEnum<LeadLinkStatus>(Object.values(LeadLinkStatus)),
  );
  const [managerStatus, setManagerStatus] = useQueryState(
    QueryParams.MANAGER_STATUS,
    parseAsStringEnum<ManagerStatus>(Object.values(ManagerStatus)),
  );
  const [payoutStatus, setPayoutStatus] = useQueryState(
    QueryParams.PAYOUT_STATUS,
    parseAsStringEnum<PayoutStatus>(Object.values(PayoutStatus)),
  );
  const [type, setType] = useQueryState(QueryParams.TYPE, { defaultValue: "" });
  const [length, setLength] = useQueryState(
    QueryParams.LENGTH,
    parseAsInteger.withDefault(10),
  );
  const [leadId, setLeadId] = useQueryState(
    QueryParams.LEAD_ID,
    parseAsString.withDefault(""),
  );
  const [isIrrelevant, setIsIrrelevant] = useQueryState(
    QueryParams.IS_IRRELEVANT,
    parseAsBoolean,
  );
  const [isActive, setIsActive] = useQueryState(
    QueryParams.IS_ACTIVE,
    parseAsBoolean,
  );
  const [isDead, setIsDead] = useQueryState(
    QueryParams.IS_DEAD,
    parseAsBoolean,
  );
  const [isBanned, setIsBanned] = useQueryState(
    QueryParams.IS_BANNED,
    parseAsBoolean,
  );
  const [excludedStatus, setExcludedStatus] = useQueryState(
    QueryParams.EXCLUDED_STATUS,
    parseAsStringEnum<LeadStatus>(Object.values(LeadStatus)),
  );
  const [selectedUserId, setSelectedUserId] = useQueryState(
    QueryParams.SELECTED_USER_ID,
  );
  const [selectedUserName, setSelectedUserName] = useQueryState(
    QueryParams.SELECTED_USER_NAME,
  );
  const [selectedUserRole, setSelectedUserRole] = useQueryState(
    QueryParams.SELECTED_USER_ROLE,
    parseAsStringEnum<Roles>(Object.values(Roles)),
  );
  const [role, setRole] = useQueryState(
    QueryParams.ROLE,
    parseAsStringEnum<Roles>(Object.values(Roles)),
  );
  const [createdAtFrom, setCreatedAtFrom] = useQueryState(
    QueryParams.CREATED_AT_FROM,
    parseAsIsoDate,
  );
  const [createdAtTo, setCreatedAtTo] = useQueryState(
    QueryParams.CREATED_AT_TO,
    parseAsIsoDate,
  );

  const [tab, setTab] = useQueryState(QueryParams.TAB, {
    defaultValue: "",
    clearOnDefault: false,
  });

  function setSelectedUser(userId: string, userRole: Roles, userName: string) {
    setSelectedUserId(userId);
    setSelectedUserRole(userRole);
    setSelectedUserName(userName);
  }

  const paramSetters = {
    [QueryParams.TAB]: setTab,
    [QueryParams.SEARCH]: setSearch,
    [QueryParams.SEARCH_BY]: setSearchByState,
    [QueryParams.PAGE]: setPage,
    [QueryParams.SORT]: setSort,
    [QueryParams.ORDER]: setOrder,
    [QueryParams.STATUS]: setStatus,
    [QueryParams.LEAD_STATUS]: setLeadStatus,
    [QueryParams.LINK_STATUS]: setLinkStatus,
    [QueryParams.MANAGER_STATUS]: setManagerStatus,
    [QueryParams.PAYOUT_STATUS]: setPayoutStatus,
    [QueryParams.TYPE]: setType,
    [QueryParams.LENGTH]: setLength,
    [QueryParams.LEAD_ID]: setLeadId,
    [QueryParams.IS_BANNED]: setIsBanned,
    [QueryParams.IS_ACTIVE]: setIsActive,
    [QueryParams.IS_IRRELEVANT]: setIsIrrelevant,
    [QueryParams.IS_DEAD]: setIsDead,
    [QueryParams.EXCLUDED_STATUS]: setExcludedStatus,
    [QueryParams.SELECTED_USER_ID]: setSelectedUserId,
    [QueryParams.SELECTED_USER_ROLE]: setSelectedUserRole,
    [QueryParams.SELECTED_USER_NAME]: setSelectedUserName,
    [QueryParams.CREATED_AT_FROM]: setCreatedAtFrom,
    [QueryParams.CREATED_AT_TO]: setCreatedAtTo,
    [QueryParams.ROLE]: setRole,
  };

  function resetUrlParams(paramsToReset?: QueryParams[]) {
    if (paramsToReset) {
      paramsToReset.forEach((param) => {
        const setter = paramSetters[param];
        if (setter) {
          setter(null);
        }
      });
    } else {
      Object.values(QueryParams).forEach((param) => {
        const setter = paramSetters[param];
        if (setter) {
          setter(null);
        }
      });
    }
  }

  return {
    search,
    setSearch,
    page,
    setPage,
    leadId,
    setLeadId,
    sort,
    setSort,
    order,
    setOrder,
    status,
    setStatus,
    leadStatus,
    setLeadStatus,
    linkStatus,
    setLinkStatus,
    managerStatus,
    setManagerStatus,
    payoutStatus,
    setPayoutStatus,
    type,
    setType,
    length,
    setLength,
    isIrrelevant,
    setIsIrrelevant,
    isBanned,
    setIsBanned,
    isDead,
    setIsDead,
    isActive,
    setIsActive,
    excludedStatus,
    setExcludedStatus,
    resetUrlParams,
    selectedUserId,
    selectedUserRole,
    selectedUserName,
    setSelectedUser,
    searchByState,
    setSearchByState,
    tab,
    setTab,
    createdAtFrom,
    setCreatedAtFrom,
    createdAtTo,
    setCreatedAtTo,
    role,
    setRole,
  };
};
